
    <div class="container">
      <app-auth-nav></app-auth-nav>
      <ng-container *ngIf="signalRSwitch == 'ON'">
      <app-application-alerts></app-application-alerts>
      </ng-container>
      <link-bar (navTo)="navigateTo($event)" [applications]="applications" [links]="links"></link-bar>
      <div style="padding-left: 15px; padding-right: 15px; display: block;">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  